import { useContext } from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import NearbyExperiencesModal from 'tripPlanner/components/TripModal/ViewMoreOffers/NearbyExperiencesModal'

interface Props {
  lat: number
  lng: number
  tripId: string
  showSearch: boolean
  className?: string
}

function ViewNearbyExperiencesCta({
  lat,
  lng,
  tripId,
  showSearch,
  className,
}: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  return (
    <TextButton
      kind="secondary"
      size="medium"
      className={className}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        showModal(
          <NearbyExperiencesModal
            lat={lat}
            lng={lng}
            tripId={tripId}
            showSearch={showSearch}
          />,
        )
      }}
    >
      {intl.formatMessage({
        id: 'Fu8KdNVFn9ze2WJT3oXS',
        defaultMessage: 'View more offers',
        description: 'Button to view nearby experience offers for a trip item',
      })}
    </TextButton>
  )
}

export default ViewNearbyExperiencesCta
